export default "__VITE_ASSET__DTsCTQSI__"